import DeleteRenderer from "../../components/AddCIPAndShutdown/deleteCellRender";
import EditRenderer from "../../components/AddCIPAndShutdown/editCellRender";
import { getIndex } from "../../utils/Utils";
import {
  dateTimeFormatter,
  dateFormatter,
  sourceFormatter,
  averageFormatter,
  predictTypeFormatter,
  valueFormatter,
  soakDurationFormatter,
} from "../../utils/tableDataFormatter";

export const HISTORIC_CIP_TABLE_COLUMNS = (t, temperature, mass) => [
  {
    headerName: t("HistoricCipTableStrings.index"),
    valueGetter: (params) => {
      if (!params.data || Object.keys(params.data).length === 0) return "";
      // Use exportIndex if present, else fallback to getIndex
      return params.data.exportIndex || getIndex(params, params.data.cleaning_start_time);
    },
    minWidth: 50,
    headerClass: "custom-Header-cip-user-table",
  },
  {
    headerName: t("HistoricCipTableStrings.start_date"),
    field: "cleaning_start_time",
    editable: false,
    flex: 1,
    valueFormatter: (params) => {
      if (!params.data || Object.keys(params.data).length === 0) return "";
      return dateTimeFormatter(params);
    },
    sortable: true,
    minWidth: 200,
    headerClass: "custom-Header-cip-user-table",
  },
  {
    headerName: t("HistoricCipTableStrings.end_date"),
    field: "cleaning_end_time",
    editable: false,
    flex: 1,
    valueFormatter: (params) => {
      if (!params.data || Object.keys(params.data).length === 0) return "";
      return dateTimeFormatter(params);
    },
    sortable: true,
    minWidth: 200,
    headerClass: "custom-Header-cip-user-table",
  },
  {
    headerName: t("HistoricCipTableStrings.next_cec_start_date"),
    field: "next_cec_start_date",
    editable: false,
    flex: 1,
    valueFormatter: (params) => {
      if (!params.data || Object.keys(params.data).length === 0) return "";
      return dateTimeFormatter(params);
    },
    sortable: true,
    minWidth: 200,
    headerClass: "custom-Header-cip-user-table",
  },
  {
    headerName: t("HistoricCipTableStrings.type"),
    field: "cleaning_type",
    editable: false,
    valueFormatter: (params) => {
      if (!params.data || Object.keys(params.data).length === 0) return "";
      return predictTypeFormatter(params, t);
    },
    flex: 1,
    sortable: true,
    minWidth: 150,
    headerClass: "custom-Header-cip-user-table",
  },
  {
    headerName: t("HistoricCipTableStrings.avg_duration_between_backwash_mins"),
    field: "avg_duration_between_backwash_mins",
    editable: false,
    valueGetter: (params) => {
      if (!params.data || Object.keys(params.data).length === 0) return "";
      return averageFormatter(
        params,
        "avg_duration_between_backwash_mins",
        "sd_duration_between_backwash_mins"
      );
    },
    flex: 1,
    sortable: true,
    minWidth: 250,
    headerClass: "custom-Header-cip-user-table",
  },
  {
    headerName: t("HistoricCipTableStrings.avg_backwash_duration_secs"),
    field: "avg_backwash_duration_secs",
    editable: false,
    valueGetter: (params) => {
      if (!params.data || Object.keys(params.data).length === 0) return "";
      return averageFormatter(
        params,
        "avg_backwash_duration_secs",
        "sd_backwash_duration_secs"
      );
    },
    flex: 1,
    sortable: true,
    minWidth: 250,
    headerClass: "custom-Header-cip-user-table",
  },
  {
    headerName: t("HistoricCipTableStrings.avg_duration_between_CEB_mins"),
    field: "avg_duration_between_CEB_mins",
    editable: false,
    valueGetter: (params) => {
      if (!params.data || Object.keys(params.data).length === 0) return "";
      return averageFormatter(
        params,
        "avg_duration_between_CEB_mins",
        "sd_duration_between_CEB_mins"
      );
    },
    flex: 1,
    sortable: true,
    minWidth: 250,
    headerClass: "custom-Header-cip-user-table",
  },
  {
    headerName: t("HistoricCipTableStrings.avg_CEB_duration_secs"),
    field: "avg_CEB_duration_secs",
    editable: false,
    valueGetter: (params) => {
      if (!params.data || Object.keys(params.data).length === 0) return "";
      return averageFormatter(
        params,
        "avg_CEB_duration_secs",
        "sd_CEB_duration_secs"
      );
    },
    flex: 1,
    sortable: true,
    minWidth: 225,
    headerClass: "custom-Header-cip-user-table",
  },
  {
    headerName: t("HistoricCipTableStrings.is_tool_identified"),
    field: "is_tool_identified",
    valueGetter: (params) => {
      if (!params.data || Object.keys(params.data).length === 0) return "";
      return sourceFormatter(params, t);
    },
    editable: false,
    flex: 1,
    sortable: true,
    minWidth: 150,
    headerClass: "custom-Header-cip-user-table",
  },
  {
    headerName: t("HistoricCipTableStrings.acid_soak_duration"),
    field: "acid_soak_duration",
    editable: false,
    flex: 1,
    sortable: true,
    valueFormatter: (params) => {
      if (!params.data || Object.keys(params.data).length === 0) return "";
      return soakDurationFormatter(params, "cleaning_type");
    },
    headerClass: "custom-Header-cip-user-table",
    minWidth: 300,
    hide: true,
  },
  {
    headerName: t("HistoricCipTableStrings.acid_used").replace("<unit>", mass),
    field: "acid_used",
    editable: false,
    flex: 1,
    sortable: true,
    valueFormatter: (params) => {
      if (!params.data || Object.keys(params.data).length === 0) return "";
      return valueFormatter(params, "cleaning_type");
    },
    headerClass: "custom-Header-cip-user-table",
    minWidth: 250,
    hide: true,
  },
  {
    headerName: t("HistoricCipTableStrings.acid_ph"),
    field: "acid_ph",
    editable: false,
    sortable: true,
    valueFormatter: (params) => {
      if (!params.data || Object.keys(params.data).length === 0) return "";
      return valueFormatter(params, "cleaning_type");
    },
    headerClass: "custom-Header-cip-user-table",
    minWidth: 150,
    hide: true,
  },
  {
    headerName: t("HistoricCipTableStrings.acid_temp").replace(
      "<unit>",
      `\u00B0${temperature}`
    ),
    field: "acid_temp",
    editable: false,
    flex: 1,
    sortable: true,
    valueFormatter: (params) => {
      if (!params.data || Object.keys(params.data).length === 0) return "";
      return valueFormatter(params, "cleaning_type");
    },
    headerClass: "custom-Header-cip-user-table",
    minWidth: 275,
    hide: true,
  },
  {
    headerName: t("HistoricCipTableStrings.alkali_soak_duration"),
    field: "alkali_soak_duration",
    editable: false,
    flex: 1,
    sortable: true,
    valueFormatter: (params) => {
      if (!params.data || Object.keys(params.data).length === 0) return "";
      return soakDurationFormatter(params, "cleaning_type");
    },
    headerClass: "custom-Header-cip-user-table",
    minWidth: 300,
    hide: true,
  },
  {
    headerName: t("HistoricCipTableStrings.alkali_used").replace(
      "<unit>",
      mass
    ),
    field: "alkali_used",
    editable: false,
    flex: 1,
    sortable: true,
    valueFormatter: (params) => {
      if (!params.data || Object.keys(params.data).length === 0) return "";
      return valueFormatter(params, "cleaning_type");
    },
    headerClass: "custom-Header-cip-user-table",
    minWidth: 250,
    hide: true,
  },
  {
    headerName: t("HistoricCipTableStrings.alkali_ph"),
    field: "alkali_ph",
    editable: false,
    flex: 1,
    sortable: true,
    valueFormatter: (params) => {
      if (!params.data || Object.keys(params.data).length === 0) return "";
      return valueFormatter(params, "cleaning_type");
    },
    headerClass: "custom-Header-cip-user-table",
    minWidth: 175,
    hide: true,
  },
  {
    headerName: t("HistoricCipTableStrings.alkali_temp").replace(
      "<unit>",
      `\u00B0${temperature}`
    ),
    field: "alkali_temp",
    editable: false,
    flex: 1,
    sortable: true,
    valueFormatter: (params) => {
      if (!params.data || Object.keys(params.data).length === 0) return "";
      return valueFormatter(params, "cleaning_type");
    },
    headerClass: "custom-Header-cip-user-table",
    minWidth: 275,
    hide: true,
  },

  // {
  //   headerName: t("HistoricCipTableStrings.add_info"),
  //   field: "add_info",
  //   hide: true,
  //   editable: true,
  //   flex: 1,
  //   sortable: true,
  //   headerClass: "custom-Header-cip-user-table",
  //   minWidth: 150,
  //   hide:true
  // },
];
